import apiClient from "../baseUrl/axiosConfig";

// Submits a registration. `answers` is a map of fieldKey -> value (arrays for
// multi-value fields). `samples` is an array of { file, performanceType, title }.
export const registerVoiceTalent = async ({ answers = {}, samples = [] }) => {
  const formData = new FormData();

  Object.entries(answers).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;

    if (Array.isArray(value)) {
      value.forEach((item) => formData.append(`answers[${key}][]`, item));
    } else {
      formData.append(`answers[${key}]`, value);
    }
  });

  samples.forEach((sample, index) => {
    if (!sample.file) return;
    formData.append("samples[]", sample.file);
    formData.append(
      `sample_performance_types[${index}]`,
      sample.performanceType || ""
    );
    formData.append(`sample_titles[${index}]`, sample.title || "");
  });

  const response = await apiClient.post("/voice-talents/register", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    // Audio samples are large; the default 10s client timeout would abort a
    // perfectly valid upload on a slow connection.
    timeout: 120000,
  });

  return response.data;
};
